"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var keys_1 = __importDefault(require("lodash/keys"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var usePrevious_1 = require("../../hooks/usePrevious");
var PostList_1 = __importDefault(require("../../components/PostList/PostList"));
var searchResultSlice_1 = require("./searchResultSlice");
var searchParamsSlice_1 = require("../searchParams/searchParamsSlice");
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var NoSearchResults_1 = require("../../components/NoSearchResults");
var filters_1 = require("../../helpers/filters");
var googleMapUtilit_1 = require("../../components/googleOverlay/googleMapUtilit");
var auth_1 = require("../../helpers/auth");
var objectHelper_1 = require("../../helpers/objectHelper");
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var PostLayout_1 = require("../../types/PostLayout");
var Localization_1 = require("../../constants/Localization");
var SearchResult = function (_a) {
    var _b, _c, _d;
    var filters = _a.filters, onAddBookmark = _a.onAddBookmark, onRemoveBookmark = _a.onRemoveBookmark, resetFilters = _a.resetFilters, handleSortChange = _a.handleSortChange, handleOpenPostPreviewBySlug = _a.handleOpenPostPreviewBySlug, paginatePosts = _a.paginatePosts, isPostCardClicked = _a.isPostCardClicked, filterIsSelected = _a.filterIsSelected, query = _a.query, public_code = _a.public_code, additionalQuery = _a.additionalQuery, locationPathName = _a.locationPathName, stateQuery = _a.stateQuery, stateFilterIsSelected = _a.stateFilterIsSelected, seoCleanLocationSubDirectoryPrefix = _a.seoCleanLocationSubDirectoryPrefix, previousLocationPathName = _a.previousLocationPathName;
    var i18n = react_i18next_1.useTranslation('common').i18n;
    var lang = i18n.language;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var postData = react_redux_1.useSelector(searchResultSlice_1.postsResult);
    var postsLoading = react_redux_1.useSelector(searchResultSlice_1.postsIsLoading);
    var token = react_redux_1.useSelector(function (state) { return state.login.token; });
    var selectedDistricts = react_redux_1.useSelector(searchParamsSlice_1.useSelectSelectedDistrictsData);
    var selectedAppliedStates = react_redux_1.useSelector(searchParamsSlice_1.useSelectAppliedStates);
    var previousIsSelected = usePrevious_1.usePrevious(filterIsSelected);
    var previousAdditionalQueryPage = usePrevious_1.usePrevious(additionalQuery.page);
    var previousStateQueryStateLength = usePrevious_1.usePrevious((_c = (_b = stateQuery.state) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
    var listingTitle = react_1.useMemo(function () {
        return filters_1.getPostListingTitle(t, locationPathName, stateQuery, filters, lang);
    }, [stateQuery, locationPathName]);
    var previousQuery = usePrevious_1.usePrevious(query);
    react_1.useEffect(function () {
        var _a, _b;
        if (!((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            previousStateQueryStateLength !== ((_b = stateQuery.state) === null || _b === void 0 ? void 0 : _b.length) &&
            !keys_1.default(additionalQuery.address).length &&
            !filterIsSelected &&
            !isPostCardClicked &&
            !public_code &&
            objectHelper_1.areObjectValuesEmpty(query)) {
            getPostsByViewBox();
        }
    }, [
        additionalQuery.viewBox,
        locationPathName,
        additionalQuery.sortBy,
        additionalQuery.page,
        query,
        stateQuery,
        isPostCardClicked,
        public_code,
    ]);
    react_1.useEffect(function () {
        var _a;
        if (!((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            !seoCleanLocationSubDirectoryPrefix &&
            filterIsSelected &&
            !isPostCardClicked) {
            getPostsByViewBox();
        }
    }, [
        seoCleanLocationSubDirectoryPrefix,
        additionalQuery.viewBox,
        query,
        previousQuery,
        previousStateQueryStateLength,
        stateQuery,
        isPostCardClicked,
        additionalQuery.page,
        additionalQuery.sortBy,
    ]);
    react_1.useEffect(function () {
        if (keys_1.default(additionalQuery.address).length &&
            additionalQuery.address &&
            !filterIsSelected &&
            !isPostCardClicked) {
            getPostsByViewBox();
        }
    }, [
        additionalQuery.address,
        additionalQuery.viewBox,
        additionalQuery.page,
        additionalQuery.sortBy,
        isPostCardClicked,
    ]);
    react_1.useEffect(function () {
        var _a;
        if (!stateFilterIsSelected &&
            !((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            additionalQuery.page !== previousAdditionalQueryPage) {
            getPostsByFilter();
        }
    }, [
        stateQuery.state,
        additionalQuery.page,
        previousAdditionalQueryPage,
        stateFilterIsSelected,
    ]);
    react_1.useEffect(function () {
        var _a, _b, _c;
        if ((filterIsSelected || stateFilterIsSelected) &&
            ((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            locationPathName === previousLocationPathName) {
            getPostsByFilter();
        }
        if (!filterIsSelected &&
            stateFilterIsSelected &&
            !((_b = stateQuery.state) === null || _b === void 0 ? void 0 : _b.length) &&
            previousStateQueryStateLength !== ((_c = stateQuery.state) === null || _c === void 0 ? void 0 : _c.length) &&
            !isUndefined_1.default(previousIsSelected) &&
            !keys_1.default(additionalQuery.address).length &&
            previousIsSelected &&
            !isPostCardClicked &&
            !public_code &&
            locationPathName !== previousLocationPathName) {
            getPostsByViewBox();
        }
    }, [
        public_code,
        query,
        stateQuery,
        locationPathName,
        previousLocationPathName,
        additionalQuery.sortBy,
        additionalQuery.page,
        isPostCardClicked,
        stateFilterIsSelected,
    ]);
    react_1.useEffect(function () {
        var _a;
        if (public_code &&
            !filterIsSelected &&
            !((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            !isPostCardClicked) {
            getPostsByFilter();
        }
    }, [
        public_code,
        filterIsSelected,
        stateQuery,
        isPostCardClicked,
        additionalQuery,
    ]);
    react_1.useEffect(function () {
        if (!(selectedAppliedStates === null || selectedAppliedStates === void 0 ? void 0 : selectedAppliedStates.length) &&
            !(selectedDistricts === null || selectedDistricts === void 0 ? void 0 : selectedDistricts.length) &&
            !seoCleanLocationSubDirectoryPrefix) {
            getPostsByFilter();
        }
    }, [
        selectedAppliedStates,
        selectedDistricts,
        seoCleanLocationSubDirectoryPrefix,
        additionalQuery.sortBy,
    ]);
    var getPostsByFilter = function () {
        var filters = __assign(__assign(__assign({ public_code: public_code }, query), stateQuery), { deal: Localization_1.PagePrefix[locationPathName] });
        if (stateQuery.state) {
            filters.state_id = stateQuery.state;
            delete filters.state;
        }
        if (stateQuery.district) {
            filters.district_id = stateQuery.district;
            delete filters.district;
        }
        dispatch(searchResultSlice_1.getPostsResultByFilter({
            filters: filters,
            page: additionalQuery.page,
            sortBy: additionalQuery.sortBy,
        }));
    };
    var getPostsByViewBox = function () {
        dispatch(searchResultSlice_1.getPostsResultByViewBox({
            filters: __assign(__assign(__assign({}, query), stateQuery), { deal: Localization_1.PagePrefix[locationPathName] }),
            page: additionalQuery.page,
            viewBox: googleMapUtilit_1.getViewBoxVertices(additionalQuery.viewBox),
            sortBy: additionalQuery.sortBy,
            withBookmarks: !!token,
        }));
        auth_1.isAuthenticated() && dispatch(searchResultSlice_1.getBookmarkedIds());
    };
    return (react_1.default.createElement("div", { className: !postsLoading
            ? "scrolling-view-port"
            : 'scrolling-view-port loading' },
        ((_d = postData.data) === null || _d === void 0 ? void 0 : _d.length) || postsLoading ? (react_1.default.createElement(PostList_1.default, { handleSortChange: handleSortChange, dealType: locationPathName, getPosts: paginatePosts, posts: postData, title: listingTitle, onAddBookmark: onAddBookmark, layout: PostLayout_1.PostLayout.SEARCH, sortBy: additionalQuery.sortBy, onRemoveBookmark: onRemoveBookmark, handleOpenPostPreviewBySlug: handleOpenPostPreviewBySlug, hideBookmarks: !token, previewUrl: GeneralSettings_1.PREVIEW_URL.preview })) : (react_1.default.createElement(NoSearchResults_1.NoSearchResult, { resetFilters: resetFilters, appliedFiltersCount: filters_1.getAppliedFiltersCount(query) })),
        react_1.default.createElement(AppFooter_1.default, { layout: "SECONDARY" })));
};
exports.default = react_1.memo(SearchResult);
